/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EmployeeViewModel } from "../types/EmployeeViewModel.ts";

export const employeeViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  postId: z.number().int().nullish(),
  codeBadge: z.string().nullish(),
  dateStart: z.optional(z.string().datetime()),
  dateFinish: z.string().datetime().nullish(),
  type: z.optional(z.number().int()),
  serviceRequestNotification: z.optional(z.boolean()),
}) as unknown as ToZod<EmployeeViewModel>;
